<template>
  <div class="zujian">
    <el-upload
      action=""
      :file-list="listImg"
      ref="upload"
      :auto-upload=false
      :on-change="imgPreview"
      list-type="picture-card"
      accept="image/*"
      :limit="1"
      :on-remove="handleRemove" :class="[isAddImg?'hidden':'']
      ">
    </el-upload>
  </div>
</template>

<script>

export default {
  name: 'uploadImg',
  props: ['img'],
  data () {
    return {
      listImg: this.img,
      isAddImg: false
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    if (this.img.length > 0) {
      this.isAddImg = true
    }
  },
  methods: {
    handleRemove (file, fileList) {
      console.log(fileList)
      if (fileList.length < 1) {
        this.isAddImg = false
      }
      this.$emit('remove', fileList)
    },

    imgPreview (file, fileList) {
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.png)$/
      if (regex.test(fileName.toLowerCase())) {
        if (fileList.length < 1) {
          this.isAddImg = false
        } else {
          this.isAddImg = true
        }
      } else {
        fileList.pop()
        this.$alert('请选择图片文件图', '系统提示')
        return false
      }
      this.$emit('change', fileList)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
</style>
